@if (enrolmentForm) {
  <div class="box" [formGroup]="enrolmentForm">
    <div>
      <h4 class="border-bottom ontario-margin-bottom-24-!">{{'ClassEnrolment.Confirmation' | translate }}</h4>
    </div>
    <app-alert-banner bannerType="alert" bannerText="{{displayLabel}}"></app-alert-banner>
    <div class="message-box">
      <mat-label class="input-label">
        <span>{{'ClassEnrolment.MessageForLearner' | translate}}  ({{'General.Optional' | translate }})</span>
      </mat-label>
      <div class="message-input">
        <textarea class='input-text' matInput formControlName="note" (change)="update()" placeholder="{{'ClassEnrolment.MessageForLearnerTooltip' | translate}}" [class.disabled]="!isEditMode" [disabled]="!isEditMode"></textarea>
      </div>
    </div>
  </div>
}
